// The ONLY file that talks to MMKV. Every persisted store goes through `persistStorage`.
// MMKV works on iOS, Android and web (localStorage under the hood).
import { createMMKV } from 'react-native-mmkv';
import { createJSONStorage, type StateStorage } from 'zustand/middleware';

export const mmkv = createMMKV({ id: 'chefi' });

const stateStorage: StateStorage = {
  getItem: key => mmkv.getString(key) ?? null,
  setItem: (key, value) => mmkv.set(key, value),
  removeItem: key => {
    mmkv.remove(key);
  },
};

export const persistStorage = createJSONStorage(() => stateStorage);
